/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * プロダクト
 */
export interface Szoa109aResponsePrdSearchResultDtoPrd { 
    /**
     * 中継店内部お客さま番号：数字
     */
    rlyisdVisitNo?: string;
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * プロダクト正式名：全角
     */
    prdAname?: string;
    /**
     * プロダクト略式名：全角
     */
    prdRyaku?: string;
    /**
     * プロダクト画面表示用略式名：全角
     */
    prdDispAname?: string;
    /**
     * 契約満了期間区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C008240」のユーザコードを設定
     */
    ctrExpireDiv?: string;
    /**
     * 契約満了期間区分名称：全半角混在
     */
    ctrExpireDivAname?: string;
    /**
     * 契約満了期間
     */
    ctrExpirePeriod?: number;
    /**
     * プロダクト種別区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C011300」のユーザコードを設定
     */
    prdClsfyDiv?: string;
    /**
     * プロダクト種別区分名称：全半角混在
     */
    prdClsfyDivAname?: string;
    /**
     * プロダクトソート番号：数字
     */
    sortNo?: string;
    /**
     * サービス種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C008410」のユーザコードを設定
     */
    srvClsfyCode?: string;
    /**
     * サービス種別コード名称：全半角混在
     */
    srvClsfyCodeAname?: string;
}

